import React from 'react'
import { RichTextMicroCopy } from 'pages/news/components/newsDetail/components/rich-text/RichText'
import { PlexForGoodTranslations } from 'pages/plex-for-good/translations'
import style from './ThankYouMessage.module.scss'

interface ThankYouMessageProps {
    translations: PlexForGoodTranslations
}

const ThankYouMessage: React.FC<ThankYouMessageProps> = ({ translations }) => {
    return (
        <div className={style.thankYouContainer}>
            <h2 className={style.thankYouTitle}>
                <RichTextMicroCopy document={translations.thankYouTitle} />
            </h2>
            <p className={style.thankYouMessage}>
                <RichTextMicroCopy document={translations.thankYouMessage} />
            </p>
        </div>
    )
}

export default ThankYouMessage
